import React, { Component, Fragment } from "react";
import { SIZE_OPTIONS } from "../constants";
import styled from "styled-components";

const SingleField = styled.div`
  padding-top: 0;
`;

const Chooser = styled.div`
  border: none;
  margin: 0 0 32px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"] + label {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 55px;
    background: #fff;
    font-size: 12px;
    cursor: pointer;
    font-weight: bold;
    color: #000;
    margin: 0 12px;
    border: 3px solid transparent;
    transition: 0.5s;
  }

  [type="radio"] + label:hover {
    background: #00210b;
    color: #fff;
  }

  [type="radio"]:checked + label,
  [type="radio"]:active + label,
  [type="radio"]:focus + label {
    border-color: #fff;
    background: #353535;
    color: #fff;
  }
  @media (max-width: 560px) {
    [type="radio"] + label {
      margin: 6px;
      font-size: 10px;
      border-radius: 5px;
      height: 20px;
      width: auto;
    }
  }
`;

class FieldOption extends Component {
  sizes = SIZE_OPTIONS[this.props.type];
  renderSize = size => {
    const { type, value } = this.props;
    const id = `${type}-${size}`;

    return (
      <Fragment key={id}>
        <input
          type="radio"
          id={id}
          name={type}
          value={size}
          onChange={this.onChange}
          checked={value.size === size && value.type === type}
        />
        <label htmlFor={id}>{size}</label>
      </Fragment>
    );
  };
  onChange = e => {
    const { type } = this.props;
    const { value } = e.currentTarget;
    this.props.onChange({ size: value, type });
  };
  renderSizes = () => {
    return <Chooser>{this.sizes.map(this.renderSize)}</Chooser>;
  };
  render() {
    const { name, img } = this.props;
    return (
      <SingleField>
        <h3>{name}</h3>
        <this.renderSizes />
        <img src={img} alt={name} />
      </SingleField>
    );
  }
}

export default FieldOption;
